export default function WhyTextingDifferent() {
  const points = [
    {
      title: 'Мышление клиента в переписке другое',
      desc: 'Когда клиент читает сообщение, он не слышит интонацию. Он интерпретирует текст через свой опыт, настроение и контекст. Одно неудачное слово — и доверие потеряно. В телефоне интонация и голос компенсируют неточность формулировок. В переписке такой страховки нет.',
    },
    {
      title: 'Скорость чтения и когнитивная нагрузка',
      desc: 'Клиент читает сообщения между другими делами. У него нет желания вникать в длинные тексты. Каждое лишнее слово — это когнитивная нагрузка, которая снижает вероятность ответа. Короткие, ясные сообщения с одним смысловым блоком работают лучше многословных абзацев.',
    },
    {
      title: 'Эффект коротких сообщений',
      desc: 'Переписка — это ритм. Чередование коротких и средних сообщений удерживает внимание. Длинные «простыни» клиент пролистывает. Динамичный диалог из 4–6 коротких сообщений даёт больше информации, чем одно огромное.',
    },
    {
      title: 'Как работает доверие в тексте',
      desc: 'В переписке доверие строится иначе. Нет голоса, нет зрительного контакта, нет языка тела. Доверие создаётся через: скорость ответа, персонализацию, конкретику, честность и заботу о времени клиента. Формальный ответ разрушает доверие быстрее, чем при телефонном разговоре.',
    },
    {
      title: 'Визуальное восприятие текста',
      desc: 'Глаз сканирует текст, а не читает каждое слово. Абзацы, пробелы, эмодзи, выделения — всё это влияет на восприятие. Сообщение без визуальной структуры клиент пропускает. Правильно оформленный текст читается за секунды и побуждает к ответу.',
    },
    {
      title: 'Эмоции в письменной коммуникации',
      desc: 'В переписке эмоции передаются сложнее. Сарказм не считывается, шутка может быть воспринята как грубость, нейтральный тон — как равнодушие. Нужно учиться управлять эмоциональным тоном текста осознанно.',
    },
    {
      title: 'Эффект «прочитал и забыл»',
      desc: 'В телефоне разговор происходит здесь и сейчас. В переписке клиент может прочитать сообщение, отвлечься и забыть о диалоге. Менеджер должен уметь возвращать клиента в диалог без назойливости и давления.',
    },
    {
      title: 'Почему нельзя копировать телефонный скрипт в чат',
      desc: 'Телефонный скрипт рассчитан на устную речь: разговорные обороты, риторические вопросы, паузы. В тексте это выглядит громоздко и неестественно. Переписка требует отдельной структуры: короче, конкретнее, с визуальным ритмом.',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-brain-line"></i>
            Экспертный разбор
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему переписка продаёт иначе, чем телефон
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Телефон и переписка — два принципиально разных канала коммуникации. Понимание этих различий определяет, закроете вы сделку или потеряете клиента.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          {points.map((item, i) => (
            <div key={i} className="flex gap-4 md:gap-6">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-sm">{i + 1}</span>
                </div>
              </div>
              <div className="bg-gray-50 rounded-xl p-5 md:p-6 border border-gray-100 flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}